<template>
  <div id="supplier-info" v-cloak>
    <div class="panel text-center">
      <div class="user-heading">
        <router-link :to="'/suppliers/' + supplier.uuid" id="profile-pic" v-if="showProfilePic">
          <img :src="supplier.image" />
        </router-link>
        <h1 :style="{ color: textColor }"><router-link :to="'/suppliers/' + supplier.uuid">{{ supplier.name }}</router-link></h1>
        <div :style="{ color: textColor }" v-html="supplier.key_info" class="user-info"></div>
        <div class="row mt-3">
          <div class="col col-sm-4 col-md-4 text-center" v-if="supplier.socmed">
            <a target="_blank" :href="'https://' + supplier.socmed">
              <i class="fa fa-globe fa-2x" :style="{ color: iconColor }"></i>
            </a>
          </div>
          <div class="col col-sm-4 col-md-4 text-center" v-if="supplier.twitter_url">
            <a target="_blank" :href="'https://' + supplier.twitter_url">
              <i class="fab fa-twitter fa-2x" :style="{ color: iconColor }"></i>
            </a>
          </div>
          <div class="col col-sm-4 col-md-4 text-center" v-if="supplier.facebook_url">
            <a target="_blank" :href="'https://' + supplier.facebook_url">
              <i class="fab fa-facebook fa-2x" :style="{ color: iconColor }"></i>
            </a>
          </div>
        </div>
      </div>
      <ul class="list-group text-left" style="border-radius: 0px 0px 4px 4px;">
        <li class="list-group-item">
          {{ translate('suppliers.projects') }}
          <span class="float-right">{{ supplier.num_proj }}</span>
        </li>
        <li class="list-group-item">
          {{ translate('suppliers.team_size') }}
          <span class="float-right">{{ supplier.our_team }}</span>
        </li>
        <li class="list-group-item">
          {{ translate('suppliers.email') }}
          <a class="float-right" :href="`mailto:${supplier.email}`">{{ supplier.email }}</a>
        </li>
        <li class="list-group-item">
          {{ translate('suppliers.phone') }}
          <a class="float-right" :href="`tel:${supplier.mobile}`">{{ supplier.mobile }}</a>
        </li>
        <li class="list-group-item">
          {{ translate('suppliers.tax') }}
          <span class="float-right">{{ supplier.registered }}</span>
        </li>
        <li class="list-group-item">
          {{ translate('suppliers.company_insurance') }}
          <span class="float-right">{{ supplier.insradio }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "supplier-info",
  props: {
    supplier: {
      required: true,
      type: Object
    },
    iconColor: {
      required: true,
      type: String
    },
    textColor: {
      required: true,
      type: String
    },
    showProfilePic: {
      required: true,
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped lang="scss">
.user-heading {
  border-radius: 4px 4px 0 0;
  color: #fff;
  padding: 20px;
  text-align: center;
  a {
    img {
      border-radius: 50%;
      margin: auto auto 10px;
      display: block;
      height: 140px;
      width: 140px;
      border: 10px solid rgba(255, 255, 255, 0.3);
    }
  }
  h1 {
    font-size: 20px;
    font-weight: 300;
    line-height: 22px;
    margin-bottom: 5px;
    margin-top: 5px;
  }
  p {
    color: #fff;
    font-size: 12px;
    margin-bottom: 0;
    text-align: center;
  }
}
#supplier-info {
  width: 100% !important;
}
</style>